import { connect } from 'react-redux';
import { getGroupsStream } from '../../redux/selectors';
var mapStateToProps = function (state) { return getGroupsStream(state); };
export default connect(mapStateToProps);
//# sourceMappingURL=GroupsList.container.js.map